import { ready, onceInitialized } from '../../lib/lifecycle/ready';

const ACTION_ID_PATTERN = /^[A-Za-z_$][\w$]*$/;

function resolveAction(name) {
  if (!ACTION_ID_PATTERN.test(name)) {
    return null;
  }

  const registry = window.modulrActions;
  if (registry && typeof registry[name] === 'function') {
    return registry[name];
  }

  const globalFn = window[name];
  if (typeof globalFn === 'function') {
    return globalFn;
  }

  return null;
}

function activate(el) {
  const name = el.dataset.modulrAction;
  if (!name) {
    return;
  }

  const fn = resolveAction(name);
  if (fn) {
    fn(el);
  }
}

function initLinkActions(root) {
  const scope = root || document;
  scope.querySelectorAll('[data-modulr-action]').forEach((el) => {
    if (!onceInitialized(el, 'link-action')) {
      return;
    }

    el.addEventListener('click', () => {
      activate(el);
    });

    el.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        activate(el);
      }
    });
  });
}

ready(initLinkActions, { scope: 'modulr-link-action' });
